(function ($) {

    $.fn.customSelect = function(){

        this.each((index, element) => {
            const $self = $(element);
            const $dropdownItems = $self.find('.dropdown-item');
            const $dropdownToggle = $dropdownItems.closest('.dropdown-menu').siblings('.dropdown-toggle');

            const $checkboxes = $self.find('.checkboxes');

            $dropdownItems.on('click', (e) => {
                e.stopImmediatePropagation();
                const $element = $(e.target);
                $dropdownItems.removeClass('active');
                $element.addClass('active');
                $dropdownToggle
                    .val($element.attr('data-value'))
                    .text($element.text());
                $self
                    .trigger('fr:update-custom-select')
                    .trigger('fr:hide-custom-select');
            });

            $checkboxes.on('click', (e) => {
                e.stopImmediatePropagation();
            })

            $checkboxes.find('label').on('click', (e) => {
                e.stopImmediatePropagation();
                e.stopPropagation();
            });

            $checkboxes.find('input').on('click', (e) => {
                e.stopPropagation();
            });

            $checkboxes.find('input').on('change', (e) => {
                e.stopImmediatePropagation();
                const element = e.target;
                isOption($(element)) ? toggleCheckboxAll(e, element) : suboptionChange(element);
                $self.trigger('fr:update-custom-select');
            });

            $self.on('fr:hide-custom-select', function(){
                $dropdownToggle
                    .removeClass('show')
                    .attr('aria-expanded', false);
                $dropdownItems.closest('.dropdown-menu')
                    .removeClass('show')
                    .removeAttr('style')
                    .removeAttr('data-popper-placement');
            });

            $self.on('fr:reset-custom-select', function(){
                $dropdownToggle
                    .val($dropdownToggle.attr('default-value'))
                    .text($dropdownToggle.attr('default-label'));
            });
        });

        function suboptionChange(element){
            const checked = $(element).closest('ul').find('input:checked').length;
            const total = $(element).closest('ul').find('input').length;
            const $option = $(element).closest('ul').closest('li').find('input');
            if(checked == total){
                if($option.length > 0){
                    $option[0].checked = true;
                }
            }else{
                if($option.length > 0){
                    $option[0].checked = false;
                }
            }
        }

        function toggleCheckboxAll(event, element){
            const isOptionChecked = $(element).is(':checked');
            const $suboptions = $(element).siblings('ul').find('input');
            $suboptions.each((index, suboption) => {
                isOptionChecked ? suboption.checked = true : suboption.checked = false;
            });
        }

        function isOption($element){
            return ($element.hasClass('option') || $element.siblings('.option').length > 0) ? true : false;
        }

        return this;

    }

    $(() => {
        $('.custom-select').customSelect();
    })

})($);


// WEBPACK FOOTER //
// ./scripts/components/custom-select.js